"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPen = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var spaui_utils_1 = require("@tencent/spaui-utils");

var info_1 = __importDefault(require("./info"));

var odc_text_1 = __importDefault(require("@tencent/odc-text"));

var IconPen = function IconPen(props) {
  return react_1["default"].createElement("svg", __assign({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), react_1["default"].createElement("path", {
    d: "M9.5 5.5l1.333 1.333",
    strokeLinecap: "square",
    stroke: "#626366"
  }), react_1["default"].createElement("path", {
    d: "M5.586 12.5H3.5v-2.086a.5.5 0 01.146-.353l7-7-.353-.354.353.354a.5.5 0 01.708 0l1.585 1.585a.5.5 0 010 .708l-7 7a.5.5 0 01-.353.146z",
    stroke: "#626366"
  }));
};

exports.IconPen = IconPen;

var Pen = function Pen(props, ref) {
  var _a;

  var // 如果想默认显示“小铅笔”，就要 showIcon，不然就是 hover 才显示
  showIcon = props.showIcon,
      onClick = props.onClick,
      _b = props.as,
      Tag = _b === void 0 ? 'span' : _b,
      // eslint-disable-line
  label = props.label,
      _c = props.textSize,
      textSize = _c === void 0 ? 'normal' : _c,
      textType = props.textType,
      iconSize = props.iconSize,
      textProps = props.textProps,
      icon = props.icon,
      iconClassName = props.iconClassName,
      iconStyle = props.iconStyle,
      iconProps = props.iconProps;
  return react_1["default"].createElement(Tag, __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-pen', {
      'always-show-pen': showIcon
    }),
    supportAllEvents: false,
    ref: ref
  }, Pen)), label ? react_1["default"].createElement(odc_text_1["default"], __assign({
    size: textSize,
    type: textType,
    className: "odc-pen-text"
  }, textProps), label) : null, react_1["default"].createElement("a", {
    className: (0, classnames_1["default"])('odc-pen-icon cursor-pointer', (_a = {}, _a['with-label'] = label, _a), iconSize, iconClassName),
    style: iconStyle,
    "aria-label": "\u7F16\u8F91",
    onClick: onClick
  }, icon || react_1["default"].createElement(exports.IconPen, __assign({
    className: "odc-pen-svg"
  }, iconProps))));
};

(0, spaui_utils_1.setComponentMark)(Pen, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Pen));